import { Navigate, useLocation } from "react-router-dom";
import { englishPathFor } from "../lib/englishPaths";
import { NotFoundRoute } from "./RouteFallbacks";

/**
 * An old Swedish address, sent on to its English one with the query string and the fragment kept
 * (build round 34, 2026-10-10). The Worker answers these with a 301 before the app is served; this
 * route is for the navigation the service worker answers from its cache, which never reaches the
 * Worker. Anything the table does not know is the ordinary not-found page.
 */
export function LegacyPathRoute() {
  const location = useLocation();
  const english = englishPathFor(location.pathname);
  if (english === null) return <NotFoundRoute />;
  return <Navigate to={`${english}${location.search}${location.hash}`} replace />;
}
